import React, { useState } from 'react'
import Topbar from './Topbar'
import { Link } from 'react-router-dom'
import Sidebar_component from './Sidebar_component'
export default function Create_Todo() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <section className='vl_dsh_bodypart_section'>
                    <div className='create_heading'>
                        <h2>Project Execution Plan</h2>
                        <h3 className='ailink mt-20'>Create plan with AI<i class="ri-apps-fill"></i></h3>
                        <div className='help_text_area mt-20'>
                            <p>Below, you can see a separate section for each day. For example, if you have 10 days, you will see 10 different sections. To add a plan for a specific day, click the 'Add Plan' button. This will open a popup where you can add a plan with a timestamp..</p>
                        </div>
                    </div>
                    <div className='plan_plate' id="planbox">

                    </div>
                </section>
            </div>
        </div>
    )
}
